/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-04-10, 12:18:00
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-10, 12:53:03
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  complainsFormHasBeenSent: false,
};

const getters = {
  complainsFormHasBeenSent: state => state.complainsFormHasBeenSent,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;



// WEBPACK FOOTER //
// ./src/store/modules/Complains/index.js